// HaderDropdown.jsx
"use client";

import React, { useState } from "react";
import Link from "next/link";
import { BiChevronRight } from "react-icons/bi";
import { blockchain1, blockchain2, blockchainMainItem, EVM1, NFT1, NFT2, NFT3, metaverse1, web3_1, web3_2, crypto1, crypto2, defi1, defi2, defi3, GenerativeAI1, GenerativeAI2, ico1, sto1, ido1, marketing1 } from "../Header/HeaderData/blockchainData";
import { gameMainItem, gameDevelopment1, gameDevelopment2, gameDevelopment3, gameArt1, gameArt2, animation1 } from "../Header/HeaderData/gameData";
import { industriesMainItem, onDemand1, foodRestaurant1, bankingFinance1, ecommerce1, ecommerce2, healthcareFitness1, healthcareFitness2, education1, education2 } from "../Header/HeaderData/industriesData";
import { aboutMainItem, companyData1, companyData2, projectCosting1, dedicatedResources1, dedicatedResources2, dedicatedResources3 } from "../Header/HeaderData/aboutData";
import Image from "next/image";

const HaderDropdown = ({ isOpen, onClose, navTextColor, mainItems, subCategoryMap }) => {
    const [selectedTab, setSelectedTab] = useState(1);

    const handleTabClick = (id) => {
        setSelectedTab(id);
    };

    // Define main items data
    const mainItemsData = { blockchainMainItem, gameMainItem, industriesMainItem, aboutMainItem };

    // Define subcategory data
    const subCategoryData = {
        NFT1, NFT2, NFT3, EVM1, blockchain1, blockchain2, metaverse1, web3_1, web3_2, crypto1, crypto2, defi1, defi2, defi3, GenerativeAI1, GenerativeAI2,  ico1, sto1, ido1, marketing1, gameDevelopment1, gameDevelopment2, gameDevelopment3, gameArt1, gameArt2, animation1, onDemand1, foodRestaurant1, bankingFinance1, ecommerce1, ecommerce2, healthcareFitness1, healthcareFitness2, education1, education2, companyData1, companyData2, projectCosting1, dedicatedResources1, dedicatedResources2, dedicatedResources3,
    };

    // Resolve main items
    const resolvedMainItems = mainItemsData[mainItems] || [];

    // Resolve subcategories
    const resolvedSubCategoryMap = {};
    for (const tab in subCategoryMap) {
        const columnsString = subCategoryMap[tab].columns;
        const columnsArray = columnsString
            .split(", ")
            .map((col) => subCategoryData[col] || []);
        resolvedSubCategoryMap[tab] = { columns: columnsArray };
    }

    const currentColumns = resolvedSubCategoryMap[selectedTab]?.columns || [];
    const columnCount = currentColumns.length;

    return (
        <div
            className={`dropdown-container ${isOpen ? "open" : ""}`}
            onMouseLeave={onClose} // This will be controlled by the parent via onHoverToggle
        >
            <div className="dropdown-content">
                {/* Left Column: Main Categories */}
                <div className="main-categories flex flex-col gap-1.5">
                    {resolvedMainItems.map((item, ind) => (
                        <div key={item.id || ind} className={`category-item ${selectedTab === item.id ? "active" : ""}`}
                            onClick={() => handleTabClick(item.id)}
                            onMouseEnter={() => handleTabClick(item.id)}
                        >
                            <span>{item.title}</span>
                            <BiChevronRight className="chevron-icon" />
                        </div>
                    ))}
                </div>

                {/* Right Area: Subcategories */}
                <div className="subcategories">
                    {resolvedSubCategoryMap[selectedTab] && (
                        <div className={`subcategory-grid grid-cols-${columnCount}`}>
                            {currentColumns.map((subList, index) => (
                                <div key={index} className={`subcategory-column first:-p-2 p-0`}>
                                    {subList.map((subItem, ind) => (
                                        <Link
                                            key={subItem.id || ind}
                                            href={subItem.href || "#"}
                                            className="subcategory-item"
                                            onClick={onClose}
                                        >
                                            {subItem.image && (
                                                <div className="bg-[#F9F6FF] p-1 rounded">
                                                    <Image
                                                        src={`${subItem.image}.webp`}
                                                        alt={`Icon for ${subItem.title}`}
                                                        width={18}
                                                        height={18}
                                                        className="subcategory-icon"
                                                    />
                                                </div>
                                            )}
                                            <span
                                                className={`subcategory-title ${navTextColor}`}
                                            >
                                                {subItem.title}
                                            </span>
                                        </Link>
                                    ))}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default HaderDropdown;
